export default __webpack_public_path__ + "locales/de/DeleteDialog.json?hash=07ec66006a5cbc8c179fe433a576060e";